import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconPaymentTypeCard = (props: IconProps) => {
  const { size = 16, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 20H22L22.2041 19.9893C23.2128 19.887 24 19.0357 24 18V6C24 4.89543 23.1046 4 22 4H2C0.895431 4 0 4.89543 0 6V18C0 19.0357 0.787223 19.887 1.7959 19.9893L2 20ZM22 19H2C1.44772 19 1 18.5523 1 18V11H23V18C23 18.5523 22.5523 19 22 19ZM23 7V6C23 5.44771 22.5523 5 22 5H2C1.44772 5 1 5.44772 1 6V7H23Z"
        fill="currentColor"
      />
    </Svg>
  );
};
